<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		title="安排时间"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：" v-show="m.id!=0">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
          <el-form-item label="上课时间：">
            <el-col :span="12">
              <el-date-picker type="datetime" placeholder="选择日期" v-model="m.newDate" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="上课老师：">
            <el-select size="mini" v-model="m.teaId">
              <el-option v-for="tea in teacherList" :label="tea.name" :value="tea.id" :key="tea.id"></el-option>
            </el-select>
          </el-form-item>

				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				id: 0,
				m: null,
        subList:[],
        teacherList:[],
        quarterList:[{id:1,name:'春季'},
          {id:2,name:'暑假'},
          {id:3,name:'秋季'},
          {id:4,name:'寒假'},
        ],

			}
		},
		methods: {
      getTeacherList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getList',
            {},
            function(res){
              this.teacherList = res.data;
              console.log('老师',res.data);
            }.bind(this),{async:false});
      },
			// 打开
			open: function(id) {

				// this.id = id;
				this.isShow = true;
				if(id == 0){	// 如果是添加
					this.m = this.create_m();
				} else {
					//id 非 0 代表 是要修改 先查询一下，把旧值显示在input中
					this.sa.ajax('api/psdAdmin/absent/getAbsentInfoById', {id: id}, function(res) {
            console.log('absentInfo',res.data);
						this.m = res.data;
						if(this.m.teaId!=null){
              this.m.teaId = parseInt(this.m.teaId);
            }else{
              this.m.teaId = '';
            }
					}.bind(this), /*{res: this.getMockData(id)}*/);
				}
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.teaId=='')) {
					return sa.error('请选择补课老师');
				}
        if(sa.isNull(m.newDate=='')) {
          return sa.error('请选择补课时间');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
        // id != 0 为修改
        this.sa.ajax('api/psdAdmin/absent/setAbsentPlan',
            {
              id:self.m.id,
              teaId:self.m.teaId,
              newDate:self.m.newDate
            },
            function(res){
          if(res.code == '0') {
            self.sa.alert('制定成功', function () {
              self.$parent.f5();	// 父视图刷新
              self.isShow = false;
            });
          }else{
            this.sa.error(res.msg || '制定失败');
          }
        });
			},
			// 创建一个空的model
			create_m: function() {
				return {
					id: 0,
					teaId: '',
          newDate:'',
				}
			},
		},
		created: function(){
			this.getTeacherList();
		}
	}
</script>
